module.exports = __webpack_public_path__ + "img/swift-boostergreenForm.4e513b78.svg";